import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5h6v14h-6l0 -14","key":"svg-0"}],["path",{"d":"M12 9h10v7h-10l0 -7","key":"svg-1"}],["path",{"d":"M14 19h6","key":"svg-2"}],["path",{"d":"M17 16v3","key":"svg-3"}],["path",{"d":"M6 13v.01","key":"svg-4"}],["path",{"d":"M6 16v.01","key":"svg-5"}]]

const IconDevicesPc = createReactComponent('outline', 'devices-pc', 'DevicesPc', __iconNode);

export default IconDevicesPc;